module.exports = __webpack_public_path__ + "img/collar_buttons_quantity.7af38a09.png";